var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-container"},[_c('select-box',{staticClass:"select-box",attrs:{"options":_vm.options,"disabled":_vm.disabled,"form-element":"","title":_vm.title,"myplaceholder":_vm.placeholder,"name":"district_name"},on:{"onselect":_vm.selectChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }